import check from './checkDataType'
import i18n from '../i18n/i18n'
import iconNormalImg from '@assets/images/marker_normal_icon.png'
import iconAlarmImg from '@assets/images/marker_alarm_icon.png'
import iconOfflineImg from '@assets/images/marker_offline_icon.png'
import iconOfflineAlarmImg from '@assets/images/marker_offline_alarm_icon.png'
let stages = [
  {power: 0, icon: 'icon-dianliang6'},
  {power: 25, icon: 'icon-dianliang_2-copy'},
  {power: 50, icon: 'icon-dianliang5'},
  {power: 75, icon: 'icon-dianliang8'},
  {power: 100, icon: 'icon-dianliang7'}
]
// 按设备电量计算得出相对应的图标
export const computedDevicePowerIcon = (power=50) => {
  if (power && check.isNumber(power * 1)) {
    // power是数字
    let stageIndex = stages.findIndex((stage) => stage.power >= power)
    // 如果有值
    if (stageIndex !== -1) {
      return stages[stageIndex].icon
    } else {
      return stages[stages.length - 1].icon
    }
  } else {
    return stages[Math.floor(stages.length / 2)].icon
  }
}

const bandStatus = {
  ok: {
    icon: 'icon-zhengchang',
    text: i18n.t('device.bandOK')
  },
  des: {
    icon: 'icon-shangxiabiaodaigaojing',
    text: i18n.t('device.bandDestroy')
  },
  up: {
    icon: 'icon-shangbiaodaigaojing',
    text: i18n.t('device.bandUp')
  },
  down:{
    icon: 'icon-xiabiaodaiposun',
    text: i18n.t('device.bandDown')
  },
}
// 计算表带损坏的图标
export const computedDeviceBandIcon = (deviceAttr={}) => {
  // console.log(deviceAttr)
  if (deviceAttr.hasOwnProperty('band')) {
    // 含有band属性则是不分上下表带的
    if (deviceAttr.band === 1) {
      // 表带损坏
      return bandStatus.des
    } else {
      return bandStatus.ok
    }
  } else if (deviceAttr.hasOwnProperty('upBand') && deviceAttr.hasOwnProperty('downBand')) {
    // 是含有上下表带的
    if (deviceAttr.upBand === 0 && deviceAttr.downBand === 0) {
      // 未破损
      return bandStatus.ok
    } else if (deviceAttr.upBand === 1 && deviceAttr.downBand === 1) {
      // 上下表带都破损
      return bandStatus.des
    } else if (deviceAttr.upBand === 1) {
      return bandStatus.up
    } else if (deviceAttr.downBand === 1) {
      return bandStatus.down
    } else {
      return bandStatus.ok
    }
  } else {
    // 没有这些属性说明表带是正常的
    return bandStatus.ok
  }
}


// 根据alarmCode来判断该显示的图标
const alarmCodes = [
  {code: 1, icon: 'icon-didianliang'},
  {code: 20, icon: 'icon-diedao'},
  {code: 21, icon: 'icon-sos'},
  {code: 22, icon: 'icon-shangxiabiaodaigaojing'},
  {code: 26, icon: 'icon-kaisuo'},
  {code: 31, icon: 'icon-weilangaojing'},
  {code: 10001, icon: 'icon-shilianrenyuan'},
  {code: 10002, icon: 'icon-xinshuai'},
  {code: 10003, icon: 'icon-jiance1'},
  {code: 27, icon: 'icon-peidai'},
  {code: 28, icon: 'icon-zhaidiao'},
  {code: 10006, icon: 'icon-tiwenyichang'},
   {code: 16, icon: 'icon-shangbandaka'},
    {code: 17, icon: 'icon-xiabandaka'},
    {code: 10007, icon: 'icon-chaoyuangaojing'},
    {code: 12, icon: 'icon-sos-cancel'},
]
export const computedAlarmIcon = (alarmCode) => {
  // ...
  // console.log(alarmCode)
  if (alarmCode && check.isNumber(alarmCode * 1)) {
    // ...
    let currentAlarm = alarmCodes.find((code) => code.code === alarmCode * 1)
    // console.log(currentAlarm)
    // return alarmCodes.find((code) => code === alarmCode * 1).icon
    return currentAlarm.icon
  }
}

// 判断实体定位方式
const entityLocationTypes = [
  {type: 'wifi', icon: 'icon-wifi', value: 'WIFI'},
  {type: 'gps', icon: 'icon-beidou', value: '卫星定位'},
  {type: 'cell', icon: 'icon-jizhan', value: '基站'},
  {type: 'mix', icon: 'icon-jizhan1', value: '混合'},
  {type: 'bluetooth', icon: 'icon-lanya', value: '蓝牙'},
  {type: '北斗', icon: 'icon-beidou', value: '卫星定位'},
  {type: 'rtk_rtd', icon: 'icon-beidou', value: 'rtk_rtd'},
  {type: 'rtk_float', icon: 'icon-beidou', value: 'rtk_float'},
  {type: 'rtk_fix', icon: 'icon-beidou', value: 'rtk_fix'},
]
// 计算实体定位方式图标
export const computedLocationIcon = (locationType='wifi', radius) => {
  let currentLocationType
  if(radius > 200 && locationType == 'cell') {
    currentLocationType = {type: 'cell', icon: 'icon-jizhan-yellow', value: '基站'}
  } else if(radius > 200 && locationType == 'wifi') {
    currentLocationType = {type: 'wifi', icon: 'icon-wifi-yellow', value: 'WIFI'}
  } else {
    currentLocationType = entityLocationTypes.find((item) => item.type === locationType)
  }
  if (currentLocationType.icon) {
    return currentLocationType.icon
  } else {
    return 'icon-wifi'
  }
}
// 计算实体定位方式图标
export const computedLocationType = (locationType='wifi') => {
  let currentLocationType = entityLocationTypes.find((item) => item.type === locationType)
  if (currentLocationType) {
    return currentLocationType
  } else {
    return entityLocationTypes[0]
  }
}

// 为字符串拼接空格
//  年龄： ---》 年  龄：
export const extendStringWithSpace = (str) => {
  // 字符串长度》=4
  if (str && check.isString(str)) {
    // ..
    if (str.length >= 4) {
      return str
    } else if (str.length === 2) {
      // 拼接空格
      let newStr = str[0] + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + str[1]
      return newStr
    } else {
      return str
    }
  } else {
    return str
  }
}

// 计算marker图片
export const computedMarkerIcon = (item) => {
  if (item.onlineStatus) {
    if (item.alarmNum && item.alarmNum > 0) {
      return iconAlarmImg
    } else {
      return iconNormalImg
    }
  } else {
    if (item.alarmNum && item.alarmNum > 0) {
      return iconOfflineAlarmImg
    } else {
      return iconOfflineImg
    }
  }
}

export default {
  computedDevicePowerIcon,
  computedDeviceBandIcon,
  computedAlarmIcon,
  entityLocationTypes,
  computedMarkerIcon,
}